export function login(
  state = {
    valid: false,
    fields: [
      {
        value: '',
        name: 'email',
        icon: 'mail_outline',
        type: 'text',
        errors: [],
        rules: {
          title: 'E-mail',
          email: {
            message: 'E-mail inválido'
          },
        }
      },
      {
        value: '',
        name: 'password',
        icon: 'lock_outline',
        type: 'password',
        errors: [],
        rules: {
          title: 'Senha',
          required: {
            message: 'Campo senha é obrigatório'
          },
        }
      }
    ]
  },
  action) {
  switch (action.type) {
    case 'VALIDATE':
      let fields = state.fields.map(item => {
        if (item.name === action.field.name) {
          return action.field
        } else {
          return item
        }
      })
      let valid =
        fields.filter(field => field.errors.length > 0).length > 0
          ? false
          : true
      return Object.assign({}, state, {
        valid: valid,
        fields: Array.from(fields)
      })
    default:
      return state
  }
}
